import * as Yup from 'yup';

import { useResolvableServiceUsageSchema } from '../../ResolvableServiceUsage/hooks/useResolvableServiceUsageSchema.hook';

export const useResolvableMissionTypeServiceUsagesSchema = () => {
  const ResolvableServiceUsageSchema = useResolvableServiceUsageSchema();

  const ResolvableMissionTypeServiceUsagesSchema = Yup.object().shape({
    serviceUsagesGroups: Yup.array()
      .of(
        Yup.object().shape({
          serviceUsages: Yup.array().of(ResolvableServiceUsageSchema),
        }),
      )
      .required('Informations requises')
      .test(
        'at-least-one-service-usage',
        'Au moins une prestation doit être renseignée',
        (serviceUsagesGroups) =>
          serviceUsagesGroups.some(
            (serviceUsagesGroup) => !!serviceUsagesGroup.serviceUsages?.length,
          ),
      ),
  });

  return ResolvableMissionTypeServiceUsagesSchema;
};
